var map = {
	"./bonus.svg": 2899,
	"./chart.svg": 5608,
	"./es.svg": 5734,
	"./esc.svg": 1392,
	"./global.svg": 3903,
	"./kyc.svg": 3502,
	"./layout.svg": 9979,
	"./left.svg": 1632,
	"./light.svg": 7276,
	"./logo.svg": 5577,
	"./news-article.svg": 2429,
	"./partner.svg": 6695,
	"./right.svg": 9130,
	"./stream.svg": 7853,
	"./twitch.svg": 4703,
	"./upload.svg": 636,
	"./user.svg": 9418,
	"./youtube.svg": 8824
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1034;